import React, { Component } from "react"
import PropTypes from "prop-types"
import AppLogoUrl from "../../images/facility-app-logo-blue.png"

export default class AppLogo extends Component {
  static propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string,
    src: PropTypes.string,
  }

  render() {
    return (
      <img
        className={"logo common-app-logo " + this.props.className}
        alt="Facility App Logo"
        src={AppLogoUrl}
        {...this.props}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/common/AppLogo.js